import React from 'react';
import Container from './Container';

const AppContainer = ({ full, ...props }) => {
    return <Container className={full ? 'app__container--full' : 'app__container'} {...props} />;
};

export default AppContainer;
